var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import appStore from '../../../images/appStore.png';
import googlePlay from '../../../images/google-play.png';
import { closeIcon } from '../../../images/icon';
import browser from './browser';
import Cookies from 'js-cookie';
import './style.scss';
import pubsub from "@viewlift/pubsub";
var AppStoreSuggestion = function () {
    var _a, _b, _c, _d, _e;
    var _f = __read(useState(parseInt(Cookies.get('AppStoreSuggestion'), 10) || 0), 2), AppStoreSuggestion = _f[0], setAppStoreSuggestion = _f[1];
    var addCookie = function () {
        // store cookie for a day
        var expiration = new Date(Date.now() + 1000 * 60 * 60 * 24);
        Cookies.set('AppStoreSuggestion', 1, { expires: expiration });
        setAppStoreSuggestion(1);
        pubsub.publish("appStoreSuggestionData", 1);
    };
    var _g = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.features, google_playstore_url = _g.google_playstore_url, itunes_store_url = _g.itunes_store_url;
    var isAndroid = browser.isAndroid() || false;
    var isIos = browser.isIOS() || false;
    var url, icon;
    if (isIos) {
        icon = appStore;
        url = itunes_store_url;
    }
    else if (isAndroid) {
        icon = googlePlay;
        url = google_playstore_url;
    }
    var openInApp = (_e = (_d = (_c = window === null || window === void 0 ? void 0 : window.app_data) === null || _c === void 0 ? void 0 : _c.appcmsMain) === null || _d === void 0 ? void 0 : _d.genericMessages) === null || _e === void 0 ? void 0 : _e.viewInAppMessage;
    if (AppStoreSuggestion === 1 || !(isAndroid || isIos)) {
        pubsub.publish("appStoreSuggestionData", 1);
        return null;
    }
    return (React.createElement("div", { className: "appstore-suggestion", role: "dialog", "aria-describedby": "appstore-suggestion-desc", "aria-label": "appstoreSuggestion" },
        React.createElement("div", { id: "appstore-suggestion-desc", className: "desc" },
            React.createElement("span", null, openInApp ? openInApp : "Would you like to view this in the app"),
            React.createElement("span", null,
                React.createElement("a", { target: "_blank", href: url, rel: "noopener noreferrer" },
                    React.createElement("img", { src: icon, alt: "store Icon" })))),
        React.createElement("div", { "aria-label": "", className: "close-button", onClick: function () { return addCookie(); } }, closeIcon())));
};
export default AppStoreSuggestion;
